import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  COMPANIES_LIST,
  COMPANIES_NEW,
  COMPANIES_EDIT,
  COMPANIES_DELETE,
  COMPANIES_EXPORT,
  COMPANIES_IMPORT,
  COMPANIES_EXPORT_ACCOUNTS,
  COMPANIES_IMPORT_ACCOUNTS,
} from "./actionTypes"

import {
  companiesListSuccess,
  companiesListError,
  companiesNewSuccess,
  companiesNewError,
  companiesDeleteSuccess,
  companiesDeleteError,
  companiesImportSuccess,
  companiesImportError,
  companiesImportAccountsSuccess,
  companiesImportAccountsError,
} from "./actions"

import {
  apiGetCompaniesList,
  apiPostCompaniesNew,
  apiPatchCompaniesEdit,
  apiDeleteCompaniesDelete,
  apiDownloadCompaniesExport,
  apiUploadCompaniesImport,
} from "../../api/calls/companies"

import {
  apiDownloadCompaniesExportAccounts,
  apiUploadCompaniesImportAccounts
} from "../../api/calls/analyticalAccounts";

function* companiesList({payload: data}) {
  try {
    const response = yield call(apiGetCompaniesList, data)
    yield put(companiesListSuccess(response))
  } catch (error) {
    yield put(companiesListError(error))
  }
}

function* companiesNew({payload: data}) {
  try {
    const response = yield call(apiPostCompaniesNew, data)
    yield put(companiesNewSuccess(response))
  } catch (error) {
    yield put(companiesNewError(error))
  }
}

function* companiesEdit({payload: data}) {
  try {
    const response = yield call(apiPatchCompaniesEdit, data)
    yield put(companiesNewSuccess(response))
  } catch (error) {
    yield put(companiesNewError(error))
  }
}

function* companiesDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteCompaniesDelete, data)
    yield put(companiesDeleteSuccess(response))
  } catch (error) {
    yield put(companiesDeleteError(error))
  }
}

function* companiesExport({payload: data}) {
  try {
    yield call(apiDownloadCompaniesExport, data)
  } catch (error) {
  }
}

function* companiesImport({payload: data}) {
  try {
    const response = yield call(apiUploadCompaniesImport, data)
    yield put(companiesImportSuccess(response))
  } catch (error) {
    yield put(companiesImportError(error))
  }
}

function* companiesExportAccounts({payload: data}) {
  try {
    yield call(apiDownloadCompaniesExportAccounts, data)
  } catch (error) {
  }
}

function* companiesImportAccounts({payload: data}) {
  try {
    const response = yield call(apiUploadCompaniesImportAccounts, data)
    yield put(companiesImportAccountsSuccess(response))
  } catch (error) {
    yield put(companiesImportAccountsError(error))
  }
}

export function* watchCompaniesList() {
  yield takeEvery(COMPANIES_LIST, companiesList);
}

export function* watchCompaniesNew() {
  yield takeEvery(COMPANIES_NEW, companiesNew);
}

export function* watchCompaniesEdit() {
  yield takeEvery(COMPANIES_EDIT, companiesEdit);
}

export function* watchCompaniesDelete() {
  yield takeEvery(COMPANIES_DELETE, companiesDelete);
}

export function* watchCompaniesExport() {
  yield takeEvery(COMPANIES_EXPORT, companiesExport);
}

export function* watchCompaniesImport() {
  yield takeEvery(COMPANIES_IMPORT, companiesImport);
}

export function* watchCompaniesExportAccounts() {
  yield takeEvery(COMPANIES_EXPORT_ACCOUNTS, companiesExportAccounts);
}

export function* watchCompaniesImportAccounts() {
  yield takeEvery(COMPANIES_IMPORT_ACCOUNTS, companiesImportAccounts);
}

function* companiesSaga() {
  yield all([
    fork(watchCompaniesList),
    fork(watchCompaniesNew),
    fork(watchCompaniesEdit),
    fork(watchCompaniesDelete),
    fork(watchCompaniesExport),
    fork(watchCompaniesImport),
    fork(watchCompaniesExportAccounts),
    fork(watchCompaniesImportAccounts),
  ]);
}

export default companiesSaga
